import { createSelector } from 'reselect';
import { resolveProp } from '@clearscore-group/lib.helpers.resolve-props';

const getDocumentsMeta = (state) => resolveProp('profile.data.documentsMeta', state);

export default createSelector(getDocumentsMeta, (documentsMeta) => ({
    documentsMeta,
}));
